import { Navigate, useLocation } from "react-router-dom";
import { hasTsSession, tsPortionRedirectPath } from "@/lib/tsIdentity";
import { isTeamHubHost, staffLoginPath } from "@/lib/teamHub";

/** Blocks TS riders / unauthorized identities; chat + inventory require Firebase TS login. */
export default function TsPortionGate({ portion, children }) {
  const { pathname, search } = useLocation();
  const embed = new URLSearchParams(search || "").get("embed") === "1";
  const caEmbed = portion === "chat" && pathname.startsWith("/ca/") && embed;
  const onTeamApp =
    isTeamHubHost() &&
    ["/kitchen", "/delivery", "/inventory", "/reports", "/salary", "/chat", "/work-ethic", "/designs"].some(
      (p) => pathname === p || pathname.startsWith(`${p}/`)
    );

  if ((pathname.startsWith("/ts/app/") || onTeamApp) && !hasTsSession()) {
    return <Navigate to={staffLoginPath(pathname)} replace state={{ from: pathname }} />;
  }
  // Embed iframe: let CaHub render its own compact login CTA (do not Navigate away).
  // Kitchen joined this list when its phone-number-only login was retired —
  // every portal now starts from the one Firebase staff login.
  if (!caEmbed && (portion === "chat" || portion === "inventory" || portion === "salary" || portion === "we" || portion === "gallery" || portion === "kitchen") && !hasTsSession()) {
    return <Navigate to={staffLoginPath(`${pathname}${search || ""}`)} replace state={{ from: pathname }} />;
  }
  if (!caEmbed) {
    const redirect = tsPortionRedirectPath(portion, pathname);
    if (redirect) return <Navigate to={redirect} replace />;
  }
  return children;
}
